import {useState, useCallback} from 'react';
import styled from 'styled-components';
import {copyEventLink} from '../utils/copyEventLink';

interface Props {
	eventId: string;
}

const Wrap = styled.span`
	position: relative;
	display: inline-flex;
	align-items: center;
`;
// Revealed on hover of the ancestor `.group` row (ActivityTimelineItem / TicketRow),
// mirroring the original Tailwind `opacity-0 group-hover:opacity-100`.
const Button = styled.button`
	border-radius: 4px;
	padding: 4px;
	border: 0;
	background: transparent;
	color: #6b6d7b;
	opacity: 0;
	transition: opacity 0.15s;
	cursor: pointer;
	.group:hover & {
		opacity: 1;
	}
	&:hover {
		background: #f5f3f9;
		color: #232334;
	}
`;
const Tooltip = styled.span`
	position: absolute;
	top: -28px;
	left: 50%;
	transform: translateX(-50%);
	white-space: nowrap;
	border-radius: 4px;
	background: #232334;
	padding: 2px 8px;
	${p => p.theme.sys.font?.detail?.['1']}
	color: #ffffff;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.2);
`;

export function CopyLinkButton({eventId}: Props) {
	const [copied, setCopied] = useState(false);

	const handleClick = useCallback(async () => {
		await copyEventLink(eventId);
		setCopied(true);
		setTimeout(() => setCopied(false), 1500);
	}, [eventId]);

	return (
		<Wrap>
			<Button type="button" aria-label="Copy link" onClick={handleClick}>
				<svg
					width="14"
					height="14"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
					<path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
				</svg>
			</Button>
			{copied && <Tooltip>Copied!</Tooltip>}
		</Wrap>
	);
}
